export default class EpgProgram {
    title:string='No Data'
    id:number = -1
    image = ''
    description= ''
    category=''
    rating = 'NR'
    rating_system = ''
    start_time=-1
    end_time=-1
    duration= -1
    uid = 0
    actionkey =  ''
    start_timeObj!:Date
    end_timeObj!:Date
}
